import React from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Logout } from "../../store/actions/AuthActions";
import { isAuthenticated } from "../../store/selectors/AuthSelectors";
import { Button } from "@mui/material";
import Logoutimg from "../../assets/images/menu/08.svg";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function LogoutPage(props) {
  const TokenDetails = JSON.parse(localStorage.getItem("userDetails"));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function onLogout() {
    let locationState = {
      code: 200,
      status: "success",
      message: "You have successfully logged out!",
    };
    if (TokenDetails.guestMode == true) {
      locationState = { code: 200, status: "success", message: "" };
    }

    dispatch(Logout(navigate, locationState));
  }
  return (
    <>
      <Button
        className="dropdown-item ai-icon"
        onClick={onLogout}
        sx={{
          background: "none",
          color: "#341439",
          fontWeight: "500",
          textTransform: "none",
          fontSize: "17px",
          padding: "0px",
        }}
      >
        <img
          src={Logoutimg}
          alt="logout"
          width={30}
          style={{ marginRight: "10px" }}
        />
        <span className="ms-2">
          {TokenDetails.guestMode == true ? "Login" : "Logout"}
        </span>
      </Button>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));
